import cx from 'clsx';
import React, { Fragment, FunctionComponent, ReactNode } from 'react';
import styles from './ResponsiveImage.module.scss';
import { ACFMedia } from 'types/media';
import { Image } from '..';
import { OnTabletAndDesktopOnly, OnMobileOnly } from 'utils/breakpoints';
import { ImageSpecificProps } from '../Image/Image';

interface OwnProps {
  children?: ReactNode;
  priority?: boolean;
  desktopImage: {
    imgProps?: Omit<JSX.IntrinsicElements['img'], 'className'> & ImageSpecificProps;
    config: ACFMedia;
  };
  mobileImage: {
    imgProps?: Omit<JSX.IntrinsicElements['img'], 'className'> & ImageSpecificProps;
    config: ACFMedia;
  };
}

type ResponsiveImageProps = Omit<JSX.IntrinsicElements['div'], 'children'> & OwnProps;

const ResponsiveImage: FunctionComponent<ResponsiveImageProps> = props => {
  const {
    className,
    priority,
    desktopImage: { imgProps: desktopImgProps, config: desktopConfig },
    mobileImage: { imgProps: mobileImgProps, config: mobileConfig },
    children,
  } = props;

  const responsiveImageClassNames = cx({
    [styles.responsiveImage]: true,
    ...(className && { [className]: true }),
  });

  return (
    <Fragment>
      <OnMobileOnly>
        {/* TODO: Responsive check */}
        <Image
          className={responsiveImageClassNames}
          acfConfig={mobileConfig}
          priority={priority}
          {...mobileImgProps}
          {...(mobileImgProps?.width && { width: mobileImgProps.width })}
          {...(mobileImgProps?.height && { height: mobileImgProps.height })}
        />
        {children}
      </OnMobileOnly>
      <OnTabletAndDesktopOnly>
        {/* TODO: Responsive check */}
        <Image
          className={responsiveImageClassNames}
          acfConfig={desktopConfig}
          priority={priority}
          {...desktopImgProps}
          {...(desktopImgProps?.width && { width: desktopImgProps.width })}
          {...(desktopImgProps?.height && { height: desktopImgProps.height })}
        />
        {children}
      </OnTabletAndDesktopOnly>
    </Fragment>
  );
};

export default ResponsiveImage;
